import styled from 'styled-components';
import {
  FileInput as FileInputBase,
  FlexContainer as FlexContainerBase,
} from '@figure/frontlib-gui';

export const FileInput = styled(FileInputBase)`
  width: 100%;

  span {
    /* Safari */
    min-width: 45%;
    overflow-wrap: break-word;
    /* chrome */
    overflow-wrap: anywhere;
  }
`;

export const FlexContainer = styled(FlexContainerBase)`
  flex-direction: column;
  gap: 1rem;
`;
